var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientOverview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.6,11.1c-0.7-0.3-1.3-0.4-1.9-0.5c-0.2,0.5-1.3,2.5-2.5,3c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 C6,13,5,11.1,4.7,10.6c-1.4,0.3-3.2,0.9-4.7,2.4c-0.1,1.3,0.1,3,0.6,3.8c0.5,0.7,1.4,1.9,5.2,2.2c0,0,1.4,0.1,2.7,0 c1.3-0.1,2.3-0.3,3-0.5L11.6,11.1L11.6,11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,7.5V18H20V7.5H12.5z M18.6,17.1h-4.7v-0.5h4.7V17.1z M18.6,15.5h-4.7V15h4.7V15.5z M18.6,13.8h-4.7v-0.5h4.7V13.8z  M18.6,12.2h-4.7v-0.5h4.7V12.2z M18.6,10.5h-4.7V10h4.7V10.5z M18.6,8.9h-4.7V8.4h4.7V8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2,6c0-0.1-0.1-0.1-0.2-0.1c0,0,0,0,0,0c0.1-0.2,0.1-0.4,0-0.6c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.1-0.2,0.1-0.4 c0-0.1,0-0.1,0-0.2c0-1.9-1.8-3.4-4-3.4c-2.2,0-4,1.5-4,3.5c0,0.1,0,0.1,0,0.2l0,0c0,0,0,0,0,0c0,0.2,0,0.2,0.1,0.3 c0.1,0.2,0.1,0.6,0.1,0.9l0,0c0,0-0.1,0-0.1,0.1C3.2,6.2,3.2,6.5,3.2,6.8c0,0.5,0.3,0.9,0.7,0.9c0.5,1.8,1.8,3.1,3.3,3.1 c1.5,0,2.8-1.3,3.3-3.1c0.4,0,0.7-0.4,0.7-0.9C11.2,6.5,11.3,6.2,11.2,6z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientOverview);
export default __webpack_public_path__ + "static/media/client-overview.23971a7925a3826268b7856fcbcde89c.svg";
export { ForwardRef as ReactComponent };